<template>
  <div>
      <wxlogin :appid="'wx5a3d790df36c54bc'" :scope="'snsapi_login'" :redirect_uri="'http://i-wq.net'"></wxlogin>
  </div>
</template>

<script>
import wxlogin from './WxLogin.vue';
export default {
  components: {wxlogin},
  mounted() {

  }
};
</script>

<style>
</style>
